import { environment } from './../../../environment/environment';
import { CompanyService } from './../../core/services/company/company.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EsnCandidatService } from '@core/services/esn-candidat/esn-candidat.service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { PhoneNumberFormat } from 'ngx-intl-telephone-input';
import { Country, IState, State } from 'country-state-city';
import { translations } from '@core/models/call-offer';
import { linkedInRegExp, patternEmail, patternNumbersOnly, urlRegExp } from '@core/models/pattern';
import { LocalStorageService } from '@core/services/local-storage.service';

@Component({
  selector: 'app-detailcompany',
  templateUrl: './detailcompany.component.html',
  styleUrls: ['./detailcompany.component.css'],
})
export class DetailcompanyComponent {
  /* number */
  tabulation: number = 10;
  /* boolean */
  disabledMode: boolean = true;
  avatar :string =''
  /* object */
  esnDetails: any;
  /* string */
  idEsn!: string;
  nameEsn!: string;
  url_image: string = environment.baseUrl + '/api/User/file/gallery_users/';
  url: string = environment.baseUrl + '/api';
  /* formGroup */
  companyDetailsForm: FormGroup = this.createCompanyDetailsForm();
  supplierDetailsForm: FormGroup = this.createSupplierDetailsForm(); 
  /* unsubscription */
  id = this.activatedRoute.snapshot.params['id'];
  type = this.activatedRoute.snapshot.params['type'];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  separateDialCode: boolean = false;
  PhoneNumberFormat = PhoneNumberFormat;
  stateList!: IState[];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  idclientConnected =
      this.localStorageService.getData('clientConnected');
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private candidatService: EsnCandidatService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    if(this.type === 'esn' || this.type === 'client final' || this.type === 'cabinet de recrutement'){
       this.getEsnById()
     }
     else {
       this.getSupplierById()
     }
  }
  ngOnInit() {
    window.scrollTo(0, 0);
  }
  createCompanyDetailsForm(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : '', [Validators.required]],
      ContactEmail: [
        data ? data.ContactEmail : '',
        [Validators.email, Validators.pattern(patternEmail)],
      ],
      linkedin_link: [ data ? data.linkedin_link : '',[Validators.pattern(linkedInRegExp)]],
      website_link: [data ? data.website_link : "", [Validators.pattern(urlRegExp)]],
      country: [data ? data.country : null],
      address: [data ? data.address : null],
      related_first_name_client: [data ? data.related_first_name: ''],
      related_last_name_client: [data ? data.related_last_name : ''],
      year_of_creation: [
        data ? new Date(data.year_of_creation).getFullYear().toString() : '',
      ],
      related_email_client: [
        data ? data.related_email : null,
        [Validators.email, Validators.pattern(patternEmail)],
      ],
      related_phone_client: [data ? data.related_phone : null],
      nb_days: [
        data ? data.nb_days : '',
        [Validators.pattern(patternNumbersOnly)],
      ],
      date_first_presentation: [data ? data.date_first_presentation : ''],
    });
  }
  createSupplierDetailsForm(data?: any) {
    console.log('data supplier', data);
    return this.formBuilder.group({
      fournisseur_first_name: [
        data ? data.first_name : '',
        [Validators.required],
      ],
      fournisseur_last_name: [
        data ? data.last_name : '',
        [Validators.required],
      ],
      linkedin_link: [data ? data.linkedin_link : '', [Validators.required]],
      fournisseur_email: [
        data ? data.email : '',
        [Validators.required],
      ],
      fournisseurPhone: [
        data ? data.phone_number : '',
        [Validators.required],
      ],
    

      logo: [data ? data.image_url : ''],
    });
    
  }
  /* get esn details */
  getEsnById() {
    this.spinner.show();
    this.companyService.getEsndetail(this.idclientConnected,this.id).subscribe({
      next: (res: any) => {
        console.log('detail company', res);
        this.spinner.hide();
        this.nameEsn = res.data[0]?.name;
        console.log('this.nameEsn', this.nameEsn);
        this.esnDetails = res.data[0];
        this.companyDetailsForm = this.createCompanyDetailsForm(
          this.esnDetails
        );
        this.companyDetailsForm.get('year_of_creation')?.setValue(
          res.data[0].year_of_creation === 'null' ||  res.data[0].year_of_creation == null ? '' :  res.data[0].year_of_creation
      );

        console.log('companyDetailsForm', this.companyDetailsForm);

        this.companyDetailsForm.disable(); // Disable the form
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  /* create add subCategory form */

  navigateToProfile() {
    if(this.type === 'fournisseur'){
      this.router.navigate(['/profil-candidats-anonyme/'+this.id]);

    }
    else {
      this.router.navigate(['/entreprises/details-entreprise/'+this.id]);
    }
  }
  getSupplierById(){

      this.spinner.show();
      this.candidatService
        .getUserById(this.id)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: any) => {
            console.log('res', res);
            this.spinner.hide();
           if (res.data[0]){
            this.esnDetails = res.data[0];
            this.supplierDetailsForm=  this.createSupplierDetailsForm(res.data[0]);
            this.avatar =res.data[0].image_url
            this.supplierDetailsForm.disable();
            console.log('dataa supplier ' , this.supplierDetailsForm , this.esnDetails,this.esnDetails?.first_name)
           }
            


          },
          error: (err: Error) => {
            this.spinner.hide();
          },
        });
    
  }
  translateCountryName(name: string): string {
  
    return translations[name] || name;
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.companyDetailsForm.get('address')?.setValue(null);
    }
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
